import type { Hotkeys, KeyboardKeys } from "owa-hotkeys";

export const defaultFormattingHotkeys: Readonly<{
    bold: KeyboardKeys;
    italic: KeyboardKeys;
    underline: KeyboardKeys;
}> = {
    bold: "ctrl+b",
    italic: "ctrl+i",
    underline: "ctrl+u",
};

export type FormattingHotkeyCommand = keyof typeof defaultFormattingHotkeys;

export const defaultComposeActionHotkeys: Readonly<{
    saveDraft: KeyboardKeys;
    insertHyperlink: KeyboardKeys;
}> = {
    saveDraft: "ctrl+s",
    insertHyperlink: "ctrl+k",
};

export type ComposeActionHotkeyCommand = keyof typeof defaultComposeActionHotkeys;

export type LocalizedComposeCommand = FormattingHotkeyCommand | ComposeActionHotkeyCommand;

export type ComposeHotkeyResolver = (command: LocalizedComposeCommand, defaultHotkey: Hotkeys) => Hotkeys;
